const { __ } = wp.i18n;

/**
 * Copies the link associated with the specified button when clicked.
 *
 * @param {string} copyElClass - The class name of the copy link button.
 * @param {string} linkAtt     - The name of the data attribute containing the link.
 */
export function copyLink( copyElClass = 'js-qala-qr-codes-copy-link-button', linkAtt = 'data-qr_code_link' ) {
	if ( ! copyElClass.length || ! linkAtt.length ) {
		return;
	}

	/**
	 * Select all copy link buttons with the specified class.
	 */
	const copyLinkButtons = document.querySelectorAll( '.' + copyElClass );

	/**
	 * Add click event listener to each copy link button.
	 */
	copyLinkButtons.forEach( button => {
		button.addEventListener( 'click', () => {
			const qrCodeLink = button.getAttribute( linkAtt );

			// Use the Clipboard API to copy the link.
			window.navigator.clipboard.writeText( qrCodeLink )
				.then( () => {
					// Change button text to "Copied".
					button.textContent = __( 'Copied', 'qala-qr-codes' );
					button.classList.add( __( 'copied', 'qala-qr-codes' ) );

					// Reset button text after a delay.
					setTimeout( () => {
						button.textContent = __( 'Copy link', 'qala-qr-codes' );
						button.classList.remove( __( 'copied', 'qala-qr-codes' ) );
					}, 1500 );
				} )
				.catch( error => { // eslint-disable-line no-unused-vars
					button.textContent = __( 'Not Copied', 'qala-qr-codes' );
					button.classList.add( __( 'not-copied', 'qala-qr-codes' ) );

					setTimeout( () => {
						button.textContent = __( 'Copy link', 'qala-qr-codes' );
						button.classList.remove( __( 'not-copied', 'qala-qr-codes' ) );
					}, 1500 );
				} );
		} );
	} );
}
